import { generateLabelClass } from "./Labels";


export const dateIsDark = (thisDate, allShowPerformances) => {
	let d = thisDate.getDate();
	let m = thisDate.getMonth() + 1;
	let y = thisDate.getFullYear();

	let formattedMonth = m > 9 ? m : '0' + m;
	let formattedDay = d > 9 ? d : '0' + d;
	let performanceOperator = y + '-' + formattedMonth + '-' + formattedDay;

	var dayIsDark = true;

	allShowPerformances.filter(showPerformance => {
		if (showPerformance.date === performanceOperator) {
			dayIsDark = false;
		}
	});
	return dayIsDark;
}

export const renderPerformanceLink = (thisPerformance, allShowPerformances) => {
	let performanceLink = '';
	let selectedPerformances = [];

	let d = thisPerformance.getDate();
	let m = thisPerformance.getMonth() + 1;
	let y = thisPerformance.getFullYear();

	let formattedMonth = m > 9 ? m : '0' + m;
	let formattedDay = d > 9 ? d : '0' + d;
	let performanceOperator = y + '-' + formattedMonth + '-' + formattedDay;

	allShowPerformances.filter(showPerformance => {
		if (showPerformance.date === performanceOperator) {
			selectedPerformances.push(showPerformance);
		}
	});

	if (selectedPerformances && selectedPerformances.length > 0) {

		const sorter = (a, b) => {
			let first = a.time.split(':')[0];
			let last = b.time.split(':')[0];
			return first - last;
		};

		selectedPerformances.sort(sorter);

		for (let index = 0; index < selectedPerformances.length; index++) {

			const perf = selectedPerformances[index];

			if (perf.time && perf.url) {

				var match = perf.time.match(/^(\d+):(\d{2})([ap]m)$/i);

				// Extracting components
				let perfHour = match[1];
				let perfMins = match[2];
				let perfAMPM = match[3];

				// Appointed Classes
				let performanceClasses = 'event-time';
				performanceClasses += ' event-time--' + perf.date;
				performanceClasses += generateLabelClass(perf);

				performanceLink += `
                    <a class="${performanceClasses}" href="${perf.url}" target="_blank">
                        ${`<span class="eth">${perfHour}</span>` + `<span class="etm">:${perfMins}</span>` + `<span class="etampm">${perfAMPM}</span>`}
                    </a>
                `;

			}

		}
	}

	return performanceLink;

}
